import { Stepper } from '../../components/Stepper';

const trustedSteps = [
  {
    img: '../../assets/android/1.png',
    description:
      'Скачайте файл сертификата на Ваш смартфон → извлеките сертификаты из архива → перейдите в «Настройки» → в поиске введите «Сертификат» → выберите «Сертификат CA»',
    button: { fileName: 'HARICA_TLS_RSA_Root_CA_2021.crt', label: 'Скачать корневые сертификаты' },
  },
  {
    img: '../../assets/android/2.png',
    description:
      'Если откроется предупреждение → нажмите «Всё равно установить» или «Установить в любом случае»',
  },
  {
    img: '../../assets/android/4.png',
    description:
      'Введите код-пароль от устройства → нажмите «Подтвердить» → в «Загрузках» выберите «HARICA_TLS_RSA_Root_CA_2021.crt». Корневой сертификат установится. В нижней части экрана появится уведомление «Сертификат ЦС установлен»',
  },
  {
    img: '../../assets/android/4.png',
    description: 'Повторите процедуру установки для каждого корневого сертификата',
  },
];

const rusTrustedSteps = [
  {
    img: '../../assets/android/2-1.png',
    description:
      'Скачайте файл сертификата на Ваш смартфон → извлеките сертификаты из архива → перейдите в «Настройки» → в поиске введите «Сертификат» → выберите «Сертификат CA» → в предупреждении нажмите «Всё равно установить» или «Установить в любом случае»',
    button: { fileName: 'HARICA_DV_TLS_RSA.crt', label: 'Скачать выпускающие сертификаты' },
  },
  {
    img: '../../assets/android/2-3.png',
    description:
      'Введите код-пароль от устройства → нажмите «Подтвердить» → в «Загрузках» выберите «HARICA_DV_TLS_RSA.crt».Выпускающий сертификат установится. В нижней части экрана появится уведомление «Сертификат ЦС установлен»',
  },
  {
    img: '../../assets/android/hresult.png',
    description:
      'Перейдите в «Настройки» → в поиске введите «Надёжные сертификаты» или «Надёжные учётные данные» → перейдите во вкладку «Пользователь». Проверьте, что установка прошла успешно',
  },
];

const AndroidPage = () => {
  return (
    <main>
      <h2>Установка сертификатов Harica на личные устройства Android</h2>

      <p>Для начала установки сертификата на Android, скачайте сертификат.</p>

      <Stepper heading="Часть 1 из 2. Корневые сертификаты" steps={trustedSteps} />

      <Stepper heading="Часть 2 из 2. Выпускающие сертификаты" steps={rusTrustedSteps} />
    </main>
  );
};

export default AndroidPage;
